var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6583 11.4083H12L11.6583 11.0667C12.7 9.9 13.3333 8.35833 13.3333 6.66667C13.3333 2.98333 10.35 0 6.66667 0C2.98333 0 0 2.98333 0 6.66667C0 10.35 2.98333 13.3333 6.66667 13.3333C8.35833 13.3333 9.9 12.7 11.075 11.6583L11.4083 12V12.6583L13.7583 15L15 13.7583L12.6583 11.4083ZM6.66667 11.6667C3.90833 11.6667 1.66667 9.425 1.66667 6.66667C1.66667 3.90833 3.90833 1.66667 6.66667 1.66667C9.425 1.66667 11.6667 3.90833 11.6667 6.66667C11.6667 9.425 9.425 11.6667 6.66667 11.6667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6583 11.4083H12L11.6583 11.0667C12.7 9.9 13.3333 8.35833 13.3333 6.66667C13.3333 2.98333 10.35 0 6.66667 0C2.98333 0 0 2.98333 0 6.66667C0 10.35 2.98333 13.3333 6.66667 13.3333C8.35833 13.3333 9.9 12.7 11.075 11.6583L11.4083 12V12.6583L13.7583 15L15 13.7583L12.6583 11.4083ZM6.66667 11.6667C3.90833 11.6667 1.66667 9.425 1.66667 6.66667C1.66667 3.90833 3.90833 1.66667 6.66667 1.66667C9.425 1.66667 11.6667 3.90833 11.6667 6.66667C11.6667 9.425 9.425 11.6667 6.66667 11.6667Z",
    fill: "#172B4D",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fe3e6d3483d267e062f84492530c9258.svg";
export { ForwardRef as ReactComponent };